<template>
<div>
  <b-container>
    <b-row>
      <b-col md="8">
        <h1>Person</h1>
        
        <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>
        
        <ValidationObserver v-slot="{ handleSubmit }">
          <b-form @submit.prevent="handleSubmit(save)">
            <b-row>
              <b-col col>
                <b-form-group
              label="Id number"
            >
              <b-form-input v-model.number="form.idNo"></b-form-input>
            </b-form-group>
            
            <b-form-group label="First name">
              <ValidationProvider name="First name" rules="required" v-slot="{ errors }">
                <b-form-input v-model="form.firstName" :state="errors[0] ? false : null"></b-form-input>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>
            
            <b-form-group
              label="Last name"
            >
              <ValidationProvider name="Last name" rules="required" v-slot="{ errors }">
                <b-form-input v-model="form.lastName" :state="errors[0] ? false : null"></b-form-input>
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </ValidationProvider>
            </b-form-group>

            <b-form-group label="Company">
              <ValidationProvider name="Company" rules="required" v-slot="{ errors }">
                <b-form-select 
                  v-model="form.companyId" 
                  :options="companies" 
                  value-field="id" 
                  text-field="name"
                  :state="errors[0] ? false : null"  
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null"></b-form-select-option>
                  </template>
                </b-form-select>
                
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>

              </ValidationProvider>
            </b-form-group>
            
            <b-form-group label="Department">
              <ValidationProvider name="Department" rules="required" v-slot="{ errors }">
                <b-form-select 
                  v-model="form.departmentId" 
                  :options="departments" 
                  value-field="id" 
                  text-field="name"
                  :state="errors[0] ? false : null"
                  @input="updateRequiredEducation"
                >
                  <template v-slot:first>
                    <b-form-select-option :value="null"></b-form-select-option>
                  </template>
                </b-form-select>
                
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>

              </ValidationProvider>
            </b-form-group>

            <div v-if="$store.getters.inRole(['Admin', 'External'])">
              <ValidationProvider vid="hasLogin">
                <b-form-group>
                  <b-form-checkbox v-model="form.loginEnabled">Login Enabled</b-form-checkbox>
                </b-form-group>
              </ValidationProvider>

              <div v-if="form.loginEnabled">
                <b-form-group label="Email">
                  <ValidationProvider name="Email" rules="required_if:hasLogin|email" v-slot="{ errors }">
                    <b-form-input v-model="form.email" :state="errors[0] ? false : null"></b-form-input>
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>

                <b-form-group label="Role">
                  <ValidationProvider name="Role" rules="required_if:hasLogin" v-slot="{ errors }">
                    <b-form-select 
                      v-model="form.role" 
                      :options="roles" 
                      :state="errors[0] ? false : null"
                    >
                      <template v-slot:first>
                        <b-form-select-option :value="null"></b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                  </ValidationProvider>
                </b-form-group>
              </div>
            </div>

            </b-col>
            <b-col id="userPhoto">
              <b-link href="#">
              <b-img :src="photoUrl" thumbnail fluid right @click="selectPhoto"></b-img>
              </b-link>
              <b-form-file accept="image/jpeg, image/png" @input="userPhotoInput" class="d-none"></b-form-file>
            </b-col>
          </b-row>

            <b-card class="my-3" no-body header-bg-variant="primary" header-text-variant="white">
              <template v-slot:header header-bg-variant="primary">
                <span class="align-middle">Required Education</span>
                <div class="float-right" v-if="$store.getters.inRole('Admin')">
                  <b-btn class="btn-circle" variant="light" @click="openAddDialog"><b-icon-plus></b-icon-plus></b-btn>
                </div>
              </template>
              <b-list-group flush>
                <b-list-group-item class="py-1" v-for="r in requiredEducationDepartment" :key="r.id" disabled>
                  <b-icon-people-fill></b-icon-people-fill>
                  {{ r.name }}
                </b-list-group-item>
                <b-list-group-item class="py-1" v-for="r in requiredEducationPerson" :key="r.id">
                  <b-icon-person-fill></b-icon-person-fill>
                  {{ r.name }}
                  <div class="float-right">
                    <b-icon-x class="point" @click="removeRequiredEducation(r.id)"></b-icon-x>
                  </div>
                </b-list-group-item>
              </b-list-group>
            </b-card>

            <b-card class="my-3" header-bg-variant="primary" header-text-variant="white" no-body>
              <template v-slot:header>
                <span class="align-middle">Education</span>
                <div class="float-right">
                  <b-btn class="btn-circle" variant="light" @click="openAddEducationDialog"><b-icon-plus></b-icon-plus></b-btn>
                </div>
              </template>
              <b-list-group flush>
                <b-list-group-item class="pb-0">
                  <b-row>
                    <b-col><strong>Name</strong></b-col>
                    <b-col><strong>Issue date</strong></b-col>
                    <b-col class="d-none d-md-block"><strong>Expiry date</strong></b-col>
                    <b-col></b-col>
                  </b-row>
                </b-list-group-item>
                <b-list-group-item v-for="(e, i) in form.education" :key="i">
                  <b-row>
                    <b-col>{{ e.educationType }}</b-col>
                    <b-col>{{ e.issueDate.substring(0, 10) }}</b-col>
                    <b-col class="d-none d-md-block">{{ (e.expiryDate || '').substring(0, 10) }}</b-col>
                    <b-col><div class="float-right">
                      <b-btn class="btn-circle mr-1" variant="outline-secondary" target="_blank" :href="`/api/personeducations/download/${e.id}`"><b-icon-card-text></b-icon-card-text></b-btn>
                      <b-btn class="btn-circle" variant="danger" @click="deleteEducation(e)"><b-icon-trash></b-icon-trash></b-btn>
                    </div></b-col>
                  </b-row>
                </b-list-group-item>
              </b-list-group>
            </b-card>

            <b-button variant="outline-secondary" class="mr-2" to="/person">Back</b-button>
            <b-button type="submit" variant="primary">Save</b-button>
          </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>

    <b-modal 
      v-model="addDialog" title="Add" @ok="addEducationTypes"
      cancel-variant="outline-secondary"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <b-form-group label="Required Training" >
        <b-form-select 
          v-model="selectedAddEducationTypes" 
          :options="listAddEducationTypes"
          value-field="id"
          text-field="name"
          :select-size=10
          multiple
        ></b-form-select>
      </b-form-group>
    </b-modal>

    <b-modal 
      title="Add Education" 
      v-model="addEducationDialog"
      ok-variant="primary"
      ok-title="Add"
      cancel-variant="outline-secondary"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="saveEducationClick"
    >
      <ValidationObserver ref="fileForm">
        <b-form @submit.prevent="saveEducationClick">
          <b-form-group label="File">
            <ValidationProvider name="File" rules="required" v-slot="{ errors }">
              <b-form-file v-model="eduForm.file" :state="errors[0] ? false : null"></b-form-file>
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>

          <b-form-group label="Education type">
            <ValidationProvider name="Education type" rules="required" v-slot="{ errors }">
              <b-form-select 
                v-model="eduForm.educationType" 
                :options="educationTypes" 
                value-field="id" 
                text-field="name"
                :state="errors[0] ? false : null"
                @change="setExpiryDate"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null"></b-form-select-option>
                </template>
              </b-form-select>
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>
          
          <b-form-group label="Issue date">
            <ValidationProvider name="Issue date" rules="required|date" v-slot="{ errors }" ref="issDate">
              <b-form-input v-model="eduForm.issueDate" :state="errors[0] ? false : null" @input="setExpiryDate"></b-form-input>
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>

          <b-form-group label="Expiry date">
            <ValidationProvider name="Expiry date" rules="date" v-slot="{ errors }">
              <b-input :value="eduForm.expiryDate" @input="eduForm.expiryDate = $event || null" :state="errors[0] ? false : null"></b-input>
              <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
            </ValidationProvider>
          </b-form-group>

        </b-form>
      </ValidationObserver>
    </b-modal>
  </b-container>
</div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import axios from 'axios';

export default {
    components: { ValidationProvider, ValidationObserver },
    data() {
      return {
        form: {
          id: 0,
          companyId: null,
          departmentId: null,
          firstName: '',
          lastName: '',
          idNo: '',
          education: [],
          requiredEducationIds: [],
          loginEnabled: false,
          email: '',
          role: '',
          userId: null,
          photoId: 0
        },
        photoUrl: '/default-user.png',
        error: '',
        companies: [],
        departments: [],
        educationTypes: [],
        addDialog: false,
        selectedAddEducationTypes: [],
        addEducationDialog: false,
        eduForm: {
          file: null,
          educationType: null,
          issueDate: '',
          expiryDate: null,
        }
      }
    },
    computed: {
      roles() {
        if (this.$store.getters.inRole('External')) {
          return ['External'];
        } else {
          return ['Admin', 'Department Manager', 'User', 'External'];
        }
      },
      departmentReqEducation() {
        const department = this.departments.find(d => { return d.id === this.form.departmentId });
        if (department) {
          return department.departmentRequiredEducationIds;
        } else {
          return [];
        }
      },
      requiredEducationDepartment() {
        return this.educationTypes.filter(t => { return this.departmentReqEducation.includes(t.id) });
      },
      requiredEducationPerson() {
        return this.educationTypes.filter(t => { return this.form.requiredEducationIds.includes(t.id) });
      },
      listAddEducationTypes() {
        const unavalableIds = [...this.departmentReqEducation, ...this.form.requiredEducationIds];
        return this.educationTypes.filter(t => { return !unavalableIds.includes(t.id) });
      }
    },
    methods: {
      save() {
        this.error = '';
        const data = {...this.form};

        data.idNo = data.idNo || 0;

        axios.post('/api/persons', data)
        .then(() => {
          this.$router.push('/person');
        })
        .catch(() => { 
          this.error = 'Failed to save';
        });
      },
      openAddDialog() {
        this.selectedAddEducationTypes = [];
        this.addDialog = true;
      },
      addEducationTypes() {
        this.selectedAddEducationTypes.forEach((id) => { this.form.requiredEducationIds.push(id); });
        this.selectedAddEducationTypes = [];
      },
      removeRequiredEducation(id) {
        const index = this.form.requiredEducationIds.indexOf(id);
        this.form.requiredEducationIds.splice(index, 1);
      },
      updateRequiredEducation() {
        this.form.requiredEducationIds = this.form.requiredEducationIds.filter(id => { return !this.departmentReqEducation.includes(id) });
      },
      openAddEducationDialog() {
        this.error = '';
        this.eduForm.file = null;
        this.eduForm.educationType = null;
        this.eduForm.issueDate = '';
        this.eduForm.expiryDate = null;
        this.addEducationDialog = true;
      },
      async saveEducationClick(evt) {
        evt.preventDefault();
        
        let success = await this.$refs.fileForm.validate();
        
        if (!success) {
          return;
        }

        let data = new FormData();

        data.append('file', this.eduForm.file);

        axios.post('/api/file', data)
          .then(res => {
            const newEducation = {
              id: 0,
              personId: this.form.id,
              educationTypeId: this.eduForm.educationType,
              educationType: this.educationTypes.find(e => e.id === this.eduForm.educationType).name,
              issueDate: this.eduForm.issueDate,
              expiryDate: this.eduForm.expiryDate,
              fileId: res.data
            };

            this.form.education.push(newEducation);
          })
          .catch(() => {
            this.error = 'Failed to add education';
          })
          .then(() =>{
            this.addEducationDialog = false;
          });        
      },
      async setExpiryDate() {
        if (!this.eduForm.educationType) return;
        if (!(await this.$refs.issDate.validateSilent()).valid) return;
        
        const eduType = this.educationTypes.find(t => this.eduForm.educationType === t.id);
        
        if (eduType && eduType.expiresIn > 0) {
          const date = new Date(this.eduForm.issueDate);
          
          switch (eduType.expiryUnit) {
            case 0:
              date.setDate(date.getDate() + eduType.expiresIn);
              break;
            case 1:
              date.setMonth(date.getMonth() + eduType.expiresIn);
              break;
            case 2:
              date.setFullYear(date.getFullYear() + eduType.expiresIn);
              break;
          }

          this.eduForm.expiryDate = date.toISOString().split('T')[0];
        }
      },
      deleteEducation(education) {
        this.form.education.splice(this.form.education.indexOf(education), 1);
      },
      userPhotoInput(file) {
        const fd = new FormData();

        fd.append('file', file);

        axios.post('/api/file', fd)
        .then((res) => {
          this.form.photoId = res.data;

          const url = URL.createObjectURL(file);
          const img = document.querySelector('#userPhoto img')
          
          img.src = url;
          img.onload = function() {
            URL.revokeObjectURL(url);
          }
        })
        .catch(() => {
          this.error = 'Failed to upload photo';
        });
      },
      selectPhoto() {
        this.error = '';
        const input = document.querySelector('#userPhoto input');
        input.click();
      }
    },
    created() {
      const companyQuery = axios.get('/api/companies');
      const departmentQuery = axios.get('/api/departments');
      const educationTypesQuery = axios.get('/api/educationtypes');

      Promise.all([companyQuery, departmentQuery, educationTypesQuery])
        .then(res => {
            this.companies = res[0].data;
            this.departments = res[1].data;
            this.educationTypes = res[2].data;
        })
        .catch(() => {
            this.error = 'Failed to load data';
        })
    }
}
</script>
<style scoped>
  .point:hover {
    cursor: pointer;
  }

  #userPhoto {
    max-width: 280px;
    max-height: 250px;
  }

  #userPhoto img {
    max-height: 250px;
  }
</style>